import { Attr, Model } from "spraypaint";
import ApplicationRecord from "./ApplicationRecord";

@Model()
class ResendInvite extends ApplicationRecord {
  static jsonapiType = "users/resend_invite";

  @Attr() userId: number;
}

export default ResendInvite;
